// extracted by mini-css-extract-plugin
export default {"publicationList":"Publications_publicationList__oE-hI","subsection":"Publications_subsection__soTl6","myName":"Publications_myName__bciBZ"};